export default __webpack_public_path__ + "static/media/on-off.aae0b653.png";